<div class="d-flex flex-column">
  <app-components-managecustomer-allocatework-task-type-period-selection
    #taskTypePeriodSelection
    [customerId]="customer().CustomerId"
    [taskTypes]="taskTypes()"
    [periods]="allPeriods()"
    [user]="user()"
    [noAvailablePeriodsErrorMessage]="noAvailablePeriodsErrorMessage"
    (addTasksOfType)="addTaskType($event.type, $event.period, $event.quantity)"
    (addCustomTaskType)="addCustomTaskType($event)"
    (addNextAvailableTaskType)="addNextAvailableItem($event.type)"
    (taskTypeChanged)="clearNoAvailablePeriodsErrorMessage()"
    (refresh)="refresh.emit()">
  </app-components-managecustomer-allocatework-task-type-period-selection>
  <div class="p-0 mb-3" [class.has-error]="currentPeriod().errors.length">
    <table class="table px-2 mb-0 border" [ngbPopover]="currentPeriod().errors.length ? currentPeriod().errors[0] : false" placement="top auto" triggers="mouseenter:mouseleave">
      <thead>
        <tr>
          <th colspan="3"><strong>Current</strong></th>
          <th><strong class="float-end">{{allocatedMinutesForPeriod(currentPeriod())}}/{{currentPeriod().minutes}}</strong></th>
        </tr>
      </thead>
      <tbody>
        @if(currentPeriod()?.taskTypeGroups?.length)
        {
          @for (group of currentPeriod().taskTypeGroups; track group)
          {
            <tr [class.bg-light]="openedTaskGroups.has(group)">
              <td class="w-75">
                @if (group.isNonworkable || group.isTemporarilyNonworkable) {
                  <i class='fas fa-stop-circle text-warning' title='Deactivated'></i>
                }
                @if (group.isManual)
                {
                  <span [ngbPopover]="group.taskTypeDescription" popoverTitle="Description" placement="left auto" triggers="mouseenter:mouseleave"
                    (click)="toggleOpenCustomTaskGroup(group)" class="cursor-pointer">
                    {{group.taskTypeName}}
                  </span>
                  <a (click)="toggleOpenCustomTaskGroup(group)" class="cursor-pointer ms-1">
                    <i [ngClass]="openedTaskGroups.has(group) ? 'fa-caret-up' : 'fa-caret-down'" class="fas"></i>
                  </a>
                }
                @else
                {
                  <span [ngbPopover]="group.taskTypeDescription" popoverTitle="Description" placement="left auto" triggers="mouseenter:mouseleave">
                    {{group.taskTypeName}}
                  </span>
                }
              </td>

              <td>
                <span class="badge bg-secondary float-end">
                  {{getGroupStatus(group.workItems)}}
                </span>
              </td>

              <td>
                @if (group.isManual)
                {
                  <span class="float-end">
                    {{group.workItems.length}}
                  </span>
                }
                @else
                {
                  <ng-select [multiple]="false" [closeOnSelect]="true" [clearable]="false" placeholder="Qty" [disabled]="!group.canChangeQuantity"
                    (ngModelChange)="groupQtyChange(group, $event, currentPeriod().period)" [ngModel]="group.workItems.length" class="float-end" style="width: 5em;">
                    <ng-option [value]="0" [disabled]="!canDeleteGroup(group)">0</ng-option>
                    <ng-option *ngFor="let qty of qtyNumbers" [value]="qty" [disabled]="qtyDisabled(qty, group)" class="text-center">
                      {{qty}}
                    </ng-option>
                  </ng-select>
                }
              </td>

              <td>
                <span class="float-end">
                  {{group.workItems.length * group.taskTypeMinutes}}
                </span>
              </td>
            </tr>
            @if (group.isManual && openedTaskGroups.has(group))
            {
              <tr>
                <td colspan="4" class="ps-4">
                  <div class="d-flex flex-column gap-2">
                    @for(item of group.workItems; track item)
                    {
                      <div>
                        @if (item.CanEdit)
                        {
                          <a (click)="editWorkRequest.emit(item)" title="Edit" class="cursor-pointer">
                            {{ item.WorkDisplayName }} <span *ngIf="item.WorkRequestWebsiteUrl">- {{ item.WorkRequestWebsiteUrl}}</span>
                          </a>
                        }
                        @else
                        {
                          {{ item.WorkDisplayName }} <span *ngIf="item.WorkRequestWebsiteUrl">- {{ item.WorkRequestWebsiteUrl}}</span>
                        }

                        @if(item.CanDelete)
                        {
                          <a (click)="deleteCustomItem(item)" title="Delete" class="cursor-pointer float-end">
                            <i class="fas fa-trash-alt fa-lg text-danger"></i>
                          </a>
                        }
                      </div>
                    }
                  </div>
                </td>
              </tr>
            }
          }
        }
        @else
        {
          <tr>
            <td colspan="4" class="text-center">
              <div class="alert alert-primary mb-0">No items</div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  @for (period of futurePeriods(); track period)
  {
    @if (period.taskTypeGroups?.length)
    {
      <div class="p-0 mb-3" [class.has-error]="period.errors.length">
        <table class="table px-2 mb-0 border" [ngbPopover]="period.errors.length ? period.errors[0] : false" placement="top auto">
          <thead>
            <tr>
              <th><strong>{{period.displayName}}</strong></th>
              <th style="width: 3em;">
                @if (period.errors?.length)
                {
                  <strong class="float-end">{{allocatedMinutesByPeriod().get(period.period)}}/{{period.minutes}}</strong>
                }
              </th>
            </tr>
          </thead>
          <tbody>
            @for (group of period.taskTypeGroups; track group)
            {
                @for (item of group.workItems; track item)
                {
                  <tr>
                    <td>
                      @if (group.isNonworkable) {
                        <i class='fas fa-stop-circle text-warning' title='Deactivated'></i>
                      }
                      <span [ngbPopover]="group.taskTypeDescription" popoverTitle="Description" placement="left auto" triggers="mouseenter:mouseleave">
                        @if (group.isManual)
                        {
                          @if (item.CanEdit)
                          {
                            <a (click)="editWorkRequest.emit(item)" title="Edit" class="cursor-pointer">
                              {{ item.WorkDisplayName }} <span *ngIf="item.WorkRequestWebsiteUrl">- {{ item.WorkRequestWebsiteUrl}}</span>
                            </a>
                          }
                          @else
                          {
                            {{ item.WorkDisplayName }} <span *ngIf="item.WorkRequestWebsiteUrl">- {{ item.WorkRequestWebsiteUrl}}</span>
                          }
                        }
                        @else
                        {
                          {{group.taskTypeName}}
                        }
                      </span>
                    </td>
                    <td>
                      @if (period.errors?.length)
                      {
                        <span>
                          {{group.taskTypeMinutes}}
                        </span>
                      }
                      @if (group.canChangeQuantity)
                      {
                        <a (click)="workRemoved.emit(item)" title="Delete" class="cursor-pointer float-end">
                          <i class="fas fa-trash-alt fa-lg text-danger"></i>
                        </a>
                      }
                    </td>
                  </tr>
                }
            }
          </tbody>
        </table>
      </div>
    }
  }
</div>